import rmskincareAPI from '../utils/rmskincareAPI'

const customerApi = {
  /* search customer purchased products, total payments, contact */
  getCustomerInfoProductsByRefId: async (refId) => {
    refId = encodeURIComponent(refId)
    let result = await rmskincareAPI.get(
      `/management/course/customer/refid?customerRefId=${refId}`
    )
    return result.data.data
  },

  /* search customer contact only */
  searchCustomer: async (query) => {
    const result = await rmskincareAPI.get(`/management/customer${query}`)
    return result.data
  },
  getCustomerAllDetailsById: async (customerId) => {
    const result = await rmskincareAPI.get(
      `management/finance?page=0&pageSize=10&str&customerId=${customerId}`
    )
    return result.data.data
  },

  // fatch customer contact info by customer id (backend generate)
  getCustomerById: async (customerId) => {
    let result = await rmskincareAPI.get(`/management/customer/${customerId}`)
    return result.data
  },

  // fatch customer contact info by refId (employee generate)
  getCustomerByRefId: async (refId) => {
    let result = await rmskincareAPI.get(`/management/customer/ref/${refId}`)
    return result.data
  },

  addEditCustomerInfo: async (requestBody) => {
    const result = await rmskincareAPI.post('/management/customer', requestBody)
    return result.data
  },

  // add course to customer
  addCourseToCustomer: async (customerId, requestBody) => {
    const result = await rmskincareAPI.post(
      `/management/course/customer/${customerId}`,
      requestBody
    )
    return result.data
  },

  sendMessageToCustomer: async (
    courseId,
    courseRecordDto,
    employeeId,
    phoneNumber
  ) => {
    let result = await rmskincareAPI.post(
      `/management/course/record/${courseId}?employeeId=${employeeId}&phoneNumber=${phoneNumber}`,
      courseRecordDto
    )
    return result.data
  },
  UpdateTimesToCustomer: async (
    courseId,
    courseProductId,
    times
  ) => {
    let result = await rmskincareAPI.put(
      `/management/course/record/times?courseId=${courseId}&courseProductId=${courseProductId}&times=${times}`
    )
    return result.data
  },
  /* down && upload */
  downloadFile: async () => {
    await rmskincareAPI
      .get('/management/customer/download', { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'customer.xlsx') //or any other extension
        document.body.appendChild(link)
        link.click()
      })
  },

  uploadFile: async (employeeId, file) => {
    const data = new FormData()

    if (file) {
      data.append('file', file)
      let res = await rmskincareAPI.post(
        `/management/customer/import?credentials=%7B%7D&details=%7B%7D&employeeId=${employeeId}&principal=%7B%7D`,
        data
      )
      return res
    }
  },

  uploadFiles: async (employeeId, files) => {
    const data = new FormData()

    data.append('employeeId',employeeId)
    if (files) {
      files.forEach((each) => {
        data.append('files', each)
      })

      let res = await rmskincareAPI.post(
        `/management/customer/import/list`,
        data
      )
      return res
    }
  },
}

export default customerApi
